module.exports = "<a href=\"https://www.beyondtabletop.com\"><h1>Beyond Tabletop</h1></a>\n"


//////////////////
// WEBPACK FOOTER
// /Users/traev/Sites/btt/src/app/public/home/home.component.html
// module id = ../../../../../src/app/public/home/home.component.html
// module chunks = main